/**
 * Common helper functions for export utilities (PDF, Excel, etc.)
 */

/**
 * Map of US state codes to full state names
 */
const STATE_MAP: { [key: string]: string } = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'FL': 'Florida',
  'GA': 'Georgia',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming'
};

/**
 * Get full state name from state code
 * @param stateCode - Two-letter state code
 * @returns Full state name or the original code if not found
 */
export const getFullStateName = (stateCode: string): string => {
  if (!stateCode) return '';
  return STATE_MAP[stateCode.toUpperCase()] || stateCode;
};

/**
 * Format state code with full name in brackets
 * @param stateCode - Two-letter state code
 * @returns Formatted string like "New York (NY)" or empty string if no code provided
 */
export const formatStateWithCode = (stateCode?: string): string => {
  if (!stateCode) return '';
  
    return stateCode.toUpperCase();
};
